import React from 'react';
import { Field } from 'redux-form';
import TextField from '@material-ui/core/TextField';


/*
<TextField
{...input}
placeholder={placeholder}
label={label}        
margin="normal"
InputProps={{
disableUnderline: true,
classes: {
    root: classes.bootstrapRoot,
    input: classes.bootstrapInput,
},
}}
InputLabelProps={{
shrink: true,
className: classes.bootstrapFormLabel,
}}
/>
*/
const renderTextField = ({input, type = "text", label, placeholder, className, style, InputProps = {}, meta: { touched, error }, disabled, required = false, readOnly = false, multiline = false, rows = 1}) => (
    <TextField
        {...input}
        type={type}
        required={required}
        placeholder={placeholder}
        label={`${label ? label : ''}${touched && error ? error : ''}`}
        className={className}
        style={style}
        error={touched && error}
        disabled={disabled}
        InputProps={{
            readOnly: readOnly,
            ...InputProps
        }}
        margin="normal"
        multiline={multiline}
        rows={rows}
    />
)
export default (obj) => {
    console.info(obj)
    return <Field component={renderTextField} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/text.js